import { createContext, useContext, useEffect, useState } from "react";
import { useAuthContext } from "./authContext";
import { ProfileRequest } from "../services/Endpoints/account";
import { useProtectedAxiosInstance } from "../hooks/axiosInstance";
import { ProfileSchema } from "../services/Schemas/User";
import { useNotificationContext } from "./notificationContext";
import errorResolver from "../utils/error-resolver";
import { AccessSectionListRequest } from "../services/Endpoints/access-section/accessSectionEndpoint";

export interface IWorkspace {
  id: number;
  name: string;
  website: null | string;
  description: null | string;
  updated_at: string;
  created_at: string;
}

export interface IProfileContext {
  userProfile: ProfileSchema | null;
  setUserProfile: (payload: ProfileSchema | null) => void;
  passwordSet: boolean;
  setPasswordSet: (payload: boolean) => void;
  accessSections?: string[];
  setAccessSections?: (payload: string[]) => void;
}

const profileContext = createContext<IProfileContext>({
  userProfile: null,
  setUserProfile: (payload: ProfileSchema | null) => false,
  passwordSet: false,
  setPasswordSet: (payload: boolean) => false,
  accessSections: [],
  setAccessSections: (payload: string[]) => false,
});

export function ProfileContextProvider({ ...props }: any) {
  const { token, logout } = useAuthContext();
  const [userProfile, setUserProfile] = useState<ProfileSchema | null>(null);
  const [passwordSet, setPasswordSet] = useState<boolean>(false);
  const [accessSections, setAccessSections] = useState<string[]>([]);

  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();

  const getData = async () => {
    const accessSectionRequest = new AccessSectionListRequest(
      protectedInstance
    );

    try {
      const {
        data: { access_sections },
      } = await accessSectionRequest.send();
      setAccessSections(access_sections.map((itm) => itm.key));
    } catch (error: any) {
      errorResolver({ error, setNotification });
    }
  };
  useEffect(() => {
    const getUserProfile = async () => {
      const profileRequest = new ProfileRequest(protectedInstance);
      try {
        const resp = await profileRequest.send();
        setUserProfile(resp.data.profile);

        setPasswordSet(!resp.data.profile.has_password);
      } catch (error) {
        console.error(error);
        errorResolver({ error, setNotification });
        setUserProfile(null);
        setPasswordSet(false);
        logout();
        return error;
      }
    };
    if (token) {
      getUserProfile();
    } else {
      setUserProfile(null);
    }
    getData();
  }, []);

  return (
    <profileContext.Provider
      value={{
        userProfile,
        setUserProfile,
        setPasswordSet,
        passwordSet,
        accessSections,
      }}
      {...props}
    />
  );
}

export const useProfileContext = () => useContext(profileContext);
